import axios from "axios";

export const authenticatedAxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});